import styled from "styled-components";

export const StyledNumericInput = styled.div`
  height: 2.5rem;
  width: 8rem;
`;
